<template>
  <div
      @click.prevent="onClick"
      class="w-24 p-4 flex flex-col items-center justify-start gap-2 overflow-hidden"
      :class="{'bg-blue-50 rounded-md': highlighted}"
  >
    <div class="h-20 w-20 shrink-0 text-center flex align-middle">
      <div v-if="!file.has_preview" class="text-center block mx-auto">
        <i :class="`p-4 text-4xl text-gray-400 fa fas mx-auto text-center ${file.icon}`"></i>
      </div>
      <img v-else :src="file.preview_url" class="object-scale-down mx-auto"/>
    </div>
    <div class="text-center text-sm w-full break-all">{{ file.filename }}</div>
  </div>
</template>

<script>

export default {
  props: {
    file: {
      type: Object,
    },
    highlighted: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      counter: 0,
      timer: null,
      doubleClickTimeout: 450
    }
  },
  computed: {},
  watch: {},
  methods: {
    previewed() {
      this.$emit('previewed', this.file)
    },
    onClick() {
      this.counter++
      this.singleClicked(false)

      if (this.counter == 1) {
        this.timer = setTimeout(() => {
          this.counter = 0
        }, this.doubleClickTimeout)

        return
      }

      if (this.counter == 2) {
        clearTimeout(this.timer)
        this.counter = 0
        this.doubleClicked()
      }

      clearTimeout(this.timer);
      this.counter = 0
    },
    singleClicked(shiftHeld) {
      this.$emit('clicked', [this.file.id, shiftHeld])
    },
    doubleClicked() {
      this.$emit('doubleClicked', this.file)
    }
  },
  mounted() {

  }
}
</script>

